import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export const HomeButton = () => (
  <a className="home-button" href="/">
    <FontAwesomeIcon icon={faArrowLeft} />
    Home
  </a>
);
